module.exports = __webpack_public_path__ + "static/img/1.11571833.png";